import { useEffect, useState } from "react";
import Tile from "../components/Tile";
import "./Home.css";

const interests = [
  { prefix: "I like", name: "Football", color: "#97f66eff" },
  { prefix: "I support", name: "Manchester United", color: "#da291c" },
  { prefix: "I am learning", name: "Japanese", color: "#0073cf" },
  { prefix: "In MotoGP I support", name: "Marc Marquez", color: "#da291c" },
  { prefix: "In F1 I support", name: "Mercedes AMG F1", color: "#00d2be" }
];

export default function Home() {
  const [index, setIndex] = useState(0);
  const current = interests[index];

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((i) => (i + 1) % interests.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="home-grid">
      {/* T1 - Who am I */}
      <Tile className="t1">
        <div className="tile-content">
          <h1 className="title">Who am I?</h1>
          <p className="subtitle">
            Hey! I'm Sahil Mandavkar, a software engineer who builds AI agent systems and the backend and data infrastructure behind them. I've led a team building a multi-tenant LangGraph platform at Heidel AI, automated data pipelines at Wolters Kluwer, and now work at IBM on healthcare claims systems handling 1M+ claims a day. I enjoy making AI agents reliable through good tools, evals, and pipelines. If you have an exciting project or challenge, feel free to reach out.
          </p>
        </div>
      </Tile>

      {/* T2 - Backend Dev */}
      <Tile className="t2">
        <h2 className="title">Backend Dev</h2>
      </Tile>

      <Tile className="t3">
        <div className="profile">
          <a
            href="https://github.com/sahill3"
            target="_blank"
            rel="noopener noreferrer"
            className="profile-link"
          >
            <img
              src="/github-identicon.png"
              alt="Sahil Mandavkar"
              className="profile-img"
            />
            <div className="profile-text">
              <h2 className="first-name">Sahil</h2>
              <h2 className="last-name">Mandavkar</h2>
            </div>
          </a>
        </div>
      </Tile>

      {/* T4 - Certifications */}
      <Tile className="t4">
        <div className="certifications">
          <h3 className="title">Certifications</h3>

          <div className="cert-scroll">
            <div className="cert-item">
              <a
                href="https://www.credly.com/badges/3f1a5434-4c22-4848-8b11-10298a07bcb6"
                target="_blank"
                rel="noopener noreferrer"
                className="cert-name"
              >
                Claude Certified Developer - Foundations
              </a>
              <p className="cert-meta">Anthropic, 2026</p>
            </div>

            <div className="cert-item">
              <a
                href="https://drive.google.com/file/d/1-dwsBU2_Zy510xyeG_xUyQNtzJPGdGoL/view?usp=drive_link"
                target="_blank"
                rel="noopener noreferrer"
                className="cert-name"
              >
                AWS Certified Cloud Practitioner (CLF-C02)
              </a>
              <p className="cert-meta">Amazon Web Services, 2026</p>
            </div>

            <div className="cert-item">
              <a
                href="https://www.udemy.com/certificate/UC-5a0db974-076e-4892-a1ec-2fa9e51de2e2/"
                target="_blank"
                rel="noopener noreferrer"
                className="cert-name"
              >
                Spring Boot 3, Spring 6 and Hibernate
              </a>
              <p className="cert-meta">Udemy, 2025</p>
            </div>
          
            <div className="cert-item">
              <a
                href="https://www.coursera.org/account/accomplishments/professional-cert/WN5RE2XM35YF"
                target="_blank"
                rel="noopener noreferrer"
                className="cert-name"
              >
                IBM Data Engineering
              </a>
              <p className="cert-meta">Coursera, 2024</p>
            </div>

            <div className="cert-item">
              <a
                href="https://www.udemy.com/certificate/UC-85110654-2e86-45dd-a578-8d5b9693d067/"
                target="_blank"
                rel="noopener noreferrer"
                className="cert-name"
              >
                C Programming
              </a>
              <p className="cert-meta">Udemy, 2024</p>
            </div>

            <div className="cert-item">
              <a
                href="https://drive.google.com/file/d/10jBBVnfy8oE0aQX6rkZdw5C7cj5tznUI/view"
                target="_blank"
                rel="noopener noreferrer"
                className="cert-name"
              >
                Introduction to User Experience Principles and Processes
              </a>
              <p className="cert-meta">Coursera, 2024</p>
            </div>

            <div className="cert-item">
              <a
                href="https://drive.google.com/file/d/1K7ykoELLHL2VBBKmJg9mScZinWkhz1_W/view"
                target="_blank"
                rel="noopener noreferrer"
                className="cert-name"
              >
                CCNAv7: Introduction to Networks
              </a>
              <p className="cert-meta">Cisco, 2023</p>
            </div>
          </div>
        </div>
      </Tile>
    
      {/* T5 - Tech Stack */}
      <Tile className="t5">
        <div className="tech-stack">
        <h3 className="title">Tech Stack</h3>
          <div className="tech-stack-content">
            <div className="tech-icon" data-name="Python">
              <img src="/python.png" alt="Python" />
            </div>
            <div className="tech-icon" data-name="Java">
              <img src="/java.png" alt="Java" />
            </div>
            <div className="tech-icon" data-name="Claude">
              <img src="/claude.png" alt="Claude" />
            </div>
            <div className="tech-icon" data-name="Docker">
              <img src="/docker.png" alt="Docker" />
            </div>
            <div className="tech-icon" data-name="Spring Boot">
              <img src="/springboot.webp" alt="Spring Boot" />
            </div>
            <div className="tech-icon" data-name="GitHub">
              <img src="/github.png" alt="GitHub" />
            </div>
            <div className="tech-icon" data-name="LangGraph">
              <img src="/langgraph.png" alt="LangGraph" className="invert" />
            </div>
            <div className="tech-icon" data-name="Pinecone">
              <img src="/pinecone.png" alt="Pinecone" className="invert" />
            </div>
            <div className="tech-icon" data-name="AWS">
              <img src="/aws.png" alt="AWS" className="invert" />
            </div>
            <div>
          </div>
            </div>
        </div>
      </Tile>

      {/* T6 - Interests */}
      <Tile className="t6">
        <div className="interest-rotator">
          <p key={index + "-p"} className="small-text">{current.prefix}</p>
          <h3 
            key={index + "-h"} 
            className="big-text fade-text"
            style={{ color: current.color }}
          >
            {current.name}
          </h3>
        </div>
      </Tile>

      {/* T7 - Education */}
      <Tile className="t7">
        <h3 className="education-title">Education</h3>
        <div className="education-block">
          <div className="edu-header">
            <h4 className="edu-title">B.Tech in AI & Data Science</h4>
            <span className="edu-year">2022-2025</span>
          </div>
          <p className="edu-subtitle">Vishwakarma Institute of Information Technology, Pune, India</p>
          <p className="edu-grade">CGPA: 9.6 / 10</p>
        </div>

        <div className="education-block">
          <div className="edu-header">
            <h4 className="edu-title">Diploma in Computer Science</h4>
            <span className="edu-year">2019-2022</span>
          </div>
          <p className="edu-subtitle">Maharashtra Institute of Technology, Pune, India</p>
          <p className="edu-grade">Percentage: 91%</p>
        </div>
      </Tile>
    </div>
  );
}
